module.exports = __webpack_public_path__ + "static/media/profil-setting.47bd4031.svg";